import { FC, useEffect } from 'react'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { SpeedcurveRUMScript } from '../../head/scripts/speedcurve-rum-script'
import { useRouter } from 'next/router'
import Head from 'next/head'

/**
 * Checks the page path to generate a page label to use to group pages within the Speedcurve RUM dashboard.
 * The label used here ideally should match any labels already created for Synthetic tests
 *
 * @param pathname
 * @returns string
 */
const setPageLabel = (path: Routes): void => {
  let pageLabel: string = path
  if (path === '/') {
    pageLabel = 'Home'
  } else if (path === Routes.FLOWPAGE) {
    pageLabel = 'Flowpage'
  }

  if (window.LUX) {
    window.LUX.label = pageLabel
  }
}

const handleRouteChangeStart = (path: Routes): void => {
  setPageLabel(path)
  window.LUX?.init()
}

const handleRouteChangeComplete = (): void => {
  window.LUX?.send()
}

export const SpeedCurve: FC = () => {
  const router = useRouter()

  useEffect(() => {
    setPageLabel(router.pathname as Routes)
  }, [router.pathname])

  useEffect(() => {
    router.events.on('routeChangeStart', handleRouteChangeStart)
    router.events.on('routeChangeComplete', handleRouteChangeComplete)

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)
      router.events.off('routeChangeComplete', handleRouteChangeComplete)
    }
  }, [router.events])

  return (
    <Head>
      <SpeedcurveRUMScript />
    </Head>
  )
}
